/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordResetAttestationData } from './PasswordResetAttestationData';
import {
    PasswordResetAttestationDataFromJSON,
    PasswordResetAttestationDataFromJSONTyped,
    PasswordResetAttestationDataToJSON,
} from './PasswordResetAttestationData';

/**
 * 
 * @export
 * @interface PasswordResetAttestationAllOf
 */
export interface PasswordResetAttestationAllOf {
    /**
     * 
     * @type {PasswordResetAttestationData}
     * @memberof PasswordResetAttestationAllOf
     */
    data?: PasswordResetAttestationData;
}

/**
 * Check if a given object implements the PasswordResetAttestationAllOf interface.
 */
export function instanceOfPasswordResetAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PasswordResetAttestationAllOfFromJSON(json: any): PasswordResetAttestationAllOf {
    return PasswordResetAttestationAllOfFromJSONTyped(json, false);
}

export function PasswordResetAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PasswordResetAttestationDataFromJSON(json['data']),
    };
}

export function PasswordResetAttestationAllOfToJSON(value?: PasswordResetAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PasswordResetAttestationDataToJSON(value.data),
    };
}

